import * as React from 'react';
import { intervalToTime } from 'utils/timeUtils';
const TIME_ORDER = ['years', 'days', 'hours', 'mins', 'secs'];
function timeChildren(type) {
    function Child(props) {
        if (!props.forceHideIfZeros && props.hideIfZero) {
            /**
             * Here were are checking if previous time units are zero.
             * Eg, 'seconds' can be hidden, if and only if 'years', 'days', 'hours' and 'minutes', are zero.
             *
             * let type = 'hours';
             * let time = { years: 0, days: 10, hours: 0, mins: 11, secs: 30 }
             *
             * shouldReturn = true;
             * key = 'years'; shouldReturn = true && true = true;   'years' !== 'hours';
             * key = 'days';  shouldReturn = true && false = false;
             * loop breaks;
             */
            let shouldReturn = true;
            let i = 0;
            do {
                let key = TIME_ORDER[i];
                shouldReturn = shouldReturn && props[key] <= 0;
                if (!shouldReturn)
                    break; // early break for some non-zero value
            } while (TIME_ORDER[i++] !== type);
            // post-increment: increment will happen only after equality check is performed
            if (shouldReturn)
                return null;
        }
        else if (props.forceHideIfZeros && props[type] <= 0) {
            return null;
        }
        return (<span>
				{props.prefix || ''}
				{props.padZeros ? `0${props[type]}`.slice(-2) : props[type]}
				{props.suffix || ''}
			</span>);
    }
    Child.displayName = `TimeInterval(${type})`;
    return Child;
}
export const Years = timeChildren('years');
export const Days = timeChildren('days');
export const Hours = timeChildren('hours');
export const Minutes = timeChildren('mins');
export const Seconds = timeChildren('secs');
/**
 * @usage
    <TimeInterval interval={150000}>
        <Hours hideIfZero padZeros suffix=' hours ' />
        <Minutes hideIfZero padZeros suffix=' minutes ' />
        <Seconds hideIfZero padZeros suffix= ' seconds' />
    </TimeInterval>
 */
export default class TimeInterval extends React.Component {
    shouldComponentUpdate(nextprops) {
        return nextprops.interval !== this.props.interval;
    }
    render() {
        const time = intervalToTime(this.props.interval, {
            useOnlyHours: this.props.useOnlyHours
        });
        if (!this.props.children) {
            return (<span>
					<Hours padZeros suffix=" : " {...time}/>
					<Minutes padZeros suffix=" : " {...time}/>
					<Seconds padZeros {...time}/>
				</span>);
        }
        return (<span>
				{React.Children.map(this.props.children, child => React.cloneElement(child, time))}
			</span>);
    }
}
